import { connect } from 'react-redux';
import EntryDataPerkelas from '../../../views/Library/EntryData/EntryDataPerkelas.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(EntryDataPerkelas);
